import ModelsStands from './models-stands';

export default ModelsStands;
